// src/pages/DashboardNavigation/DashboardNavigation.jsx

import React from "react";

import useDashboardNavigation from "./hooks/useDashboardNavigation";

import {
  NavigationDrawer,
  NavigationSkeleton,
  PageIndicator,
  StepButton,
  TimelineStrip,
} from "./components";

export default function DashboardNavigation({ role }) {
  const {
    loaded,
    sections,
    total,

    currentIndex,
    currentPage,
    previousPage,
    nextPage,
    nearbyPages,
    progress,

    drawerOpen,
    setDrawerOpen,

    activeSectionId,
    setActiveSectionId,

    goTo,
    goPrevious,
    goNext,
  } = useDashboardNavigation(role);

  if (!loaded) {
    return <NavigationSkeleton />;
  }

  return (
    <nav
      className="overflow-hidden rounded-[1.5rem] border border-slate-200/80 bg-white/95 p-2 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-900/95"
      aria-label="Navigation interne du tableau de bord"
    >
      <div className="grid grid-cols-[1fr_auto_1fr] items-stretch gap-2">
        <StepButton
          direction="previous"
          page={previousPage}
          onClick={goPrevious}
        />

        <PageIndicator
          currentPage={currentPage}
          currentIndex={currentIndex}
          total={total}
          drawerOpen={drawerOpen}
          onToggle={() => setDrawerOpen((previous) => !previous)}
        />

        <StepButton direction="next" page={nextPage} onClick={goNext} />
      </div>

      <TimelineStrip pages={nearbyPages} onGoTo={goTo} />

      <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
        <div
          className="h-full rounded-full bg-gradient-to-r from-orange-400 via-sky-500 to-indigo-500 transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>

      <NavigationDrawer
        open={drawerOpen}
        sections={sections}
        activeSectionId={activeSectionId}
        onChangeSection={setActiveSectionId}
        currentPath={currentPage?.path}
        onGoTo={goTo}
        onClose={() => setDrawerOpen(false)}
      />
    </nav>
  );
}